import { Injectable } from '@angular/core';
import { CominicationService } from '../../services/cominication.service';
// import { ComminicationService } from 'src/core/services/comminication.service';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  constructor(private comService: CominicationService) {}

  showLoading(fromResolver = false) {
    if (fromResolver) {
      this.comService.sendMessage('loading-show-resolver');
    } else {
      this.comService.sendMessage('loading-show');
      setTimeout(() => {
        this.comService.sendMessage('loading-hide');
      }, 10000);
    }
  }

  hideLoading(fromResolver = false) {
    if (fromResolver) {
      this.comService.sendMessage('loading-hide-resolver');
    } else {
      this.comService.sendMessage('loading-hide');
    }
  }
}
